module.exports = __webpack_public_path__ + "img/hydol_top.4e18bff8.jpg";